import { render, staticRenderFns } from "./ShopInfoBackgroundImage.vue?vue&type=template&id=c0d2eb68&scoped=true"
import script from "./ShopInfoBackgroundImage.vue?vue&type=script&lang=js"
export * from "./ShopInfoBackgroundImage.vue?vue&type=script&lang=js"
import style0 from "./ShopInfoBackgroundImage.vue?vue&type=style&index=0&id=c0d2eb68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d2eb68",
  null
  
)

export default component.exports